/*                                     */
/*                                     */
import type { Class } from "type-fest";
import { toggle } from "@otto-ec/global-resources/toggle";
import type { CustomElement } from "./utils";
import { extendElementAsFormAssociated } from "./extend.formAssociated";
import { extendElementWithInputBehavior } from "./extend.inputBehavior";
import { extendElementBase } from "./extend.base";
import {
  extendElementWithAnimationFrameInit,
  extendElementWithRenderSliceInit,
} from "./extend.initializers";

declare global {
  interface Window {
    /**
 *
 *
 */
    __components: {
      /**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
      extend: typeof extendCustomElement;
    };
  }
}

/**
 *
 *
 *
 *
 */
function extendCustomElement({
  formAssociated,
  inputBehavior,
}: {
  /**
 *
 *
 */
  formAssociated?: true;
  /**
 *
 *
 */
  inputBehavior?: true;
} = {}) {
  return (customElement: Class<HTMLElement>): CustomElement => {
    let result = extendElementBase(customElement as CustomElement);

    /*                                                */
    if (toggle.get("oc_init_with_render_slice", false)) {
      result = extendElementWithRenderSliceInit(result);
    } else if (toggle.get("oc_init_with_animation_frame", false)) {
      result = extendElementWithAnimationFrameInit(result);
    }

    /*                                                               */
    if (formAssociated) result = extendElementAsFormAssociated(result);

    /*                                               */
    if (inputBehavior) result = extendElementWithInputBehavior(result);

    return result;
  };
}

window.__components ??= {} as never;
window.__components.extend = extendCustomElement;
